import React, { memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const TitleSmall = memo(({ title, color }) => {
  const useStyles = makeStyles((theme) => ({
    title: {
      fontSize: 24,
      fontFamily: "Gotham Rounded",
      textTransform: "uppercase",
      color: theme.palette[color].main,
      letterSpacing: -1,
      marginBottom: 0,
    },
  }));
  const classes = useStyles();
  return <h1 className={classes.title}>{title}</h1>;
});

TitleSmall.displayName = "TitleSmall";

TitleSmall.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
};

export default TitleSmall;
